import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Aguardando from '../common/template/aguardando';

import { setModoTela, getLista } from './reportsIntegracaoTetraPakActions';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndTextarea from '../common/form/labelAndTextarea';
import Select from '../common/form/select';
import LabelAndInputMask from '../common/form/labelAndInputMask';

class ReportsIntegracaoTetraPak extends Component {

	state = {
		data_inicial: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAnterior(30)),
		data_final: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}

    componentWillMount() {
        this.props.getLista();
    }

    render() {
        return (
            <div>
                <Content>

					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {

		return (
			<ContentCard>
				
				{this.modalCodigo()}

				<ContentCardHeader>
					<Row>
						<LabelAndInputMask
							label='Data/Hora' placeholder='Informe o período inicial'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.state.data_inicial}
							onChange={(data) => {
								this.setState({ ...this.state, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							label='Data/Hora' placeholder='Informe o período final'
							cols='12 6 3 2'
							mask='99/99/9999'
							value={this.state.data_final}
							onChange={(data) => {
								this.setState({ ...this.state, data_final: data.target.value });
							}} />

						<Grid cols='6 6 4 2' style={{ marginTop: 28 }}>
							<Button
								text='Atualizar'
								type={'primary'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.getLista(this.state.data_inicial, this.state.data_final);
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />

					<Table responsive>
						<THead>
							<Tr>
								<Th rowspan={2} alignCenter>Solicitação</Th>
								<Th rowspan={2} alignCenter>Referência</Th>
								<Th rowspan={2} alignCenter>Inclusão</Th>
								<Th colspan={2} alignCenter>Primeiro Enviado</Th>
								<Th colspan={2} alignCenter>Último Enviado</Th>
								<Th rowspan={2} alignCenter>Quantidade</Th>
								<Th rowspan={2} alignCenter>Status</Th>
							</Tr>
							<Tr>
								<Th alignCenter>Data Hora</Th>
								<Th alignCenter>Registro</Th>
								<Th alignCenter>Data Hora</Th>
								<Th alignCenter>Registro</Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.filter(item => {

								if (this.state.pesquisar
									&& !(`${item.solicitacao}
										${item.registro_ultimo_envio ? item.registro_ultimo_envio.billOfLading : ''}
										${item.erro ? 'Sucesso' : 'Erro'}
									`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
									return false;
								}

								return true;
							}).map(item => (
								<Tr key={item.solicitacao}>
									<Td alignCenter>{item.solicitacao}</Td>
									<Td alignCenter>{item.registro_ultimo_envio ? item.registro_ultimo_envio.billOfLading : ''}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_primeiro_envio)}</Td>
									<Td alignCenter 
										title={''}>
										{item.registro_primeiro_envio &&
										<ButtonTable
											type={'secondary'}
											icon={'fas fa-code'}
											visible={true}
											event={() => {
												this.setState({
													...this.state,
													registroJson: {
														...item.registro_primeiro_envio
													}
												});
											}} />}
									</Td>
									<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_ultimo_envio)}</Td>
									<Td alignCenter 
										title={''}>
										{item.registro_ultimo_envio &&
										<ButtonTable
											type={'secondary'}
											icon={'fas fa-code'}
											visible={true}
											event={() => {
												this.setState({
													...this.state,
													registroJson: {
														...item.registro_ultimo_envio
													}
												});
											}} />}
									</Td>
									<Td alignCenter>{item.quantidade}</Td>
									<Td alignCenter>
										{!item.erro ? (
											<span class='badge badge-success' style={{ fontSize: 14, width: 90, padding: 6 }}>Sucesso</span>
										) : (
											<span class='badge badge-danger' title={item.erro} style={{ fontSize: 14, width: 90, padding: 6 }}>Erro</span>
										)}
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

	modalCodigo() {

		if (!this.state.registroJson) {
			return null;
		}

        return (
			<div class='modal fade show' id='modal-xl' style={{ display: 'block' }} aria-modal='true'>
				<div class='modal-dialog modal-xl'>
					<div class='modal-content'>
						<div class='modal-header' style={{ backgroundColor: '#1F3066', color: '#fff' }}>
							<h4 class='modal-title'>{'JSON'}</h4>
							<button type='button' class='close' data-dismiss='modal' aria-label='Close' onClick={() => this.setState({ ...this.state, registroJson: null, registroErro: null })}>
								<span aria-hidden='true' style={{ color: '#fff', fontSize: 32 }}>×</span>
							</button>
						</div>
						<div class='modal-body' style={{ overflowY: 'scroll', paddingTop: 20 }}>
							
							<p style={{ padding: 20, backgroundColor: '#e9ecef', color: '#000', fontSize: 16 }}>
								{JSON.stringify(this.state.registroJson)}
							</p>
						</div>
					</div>
				</div>
			</div>
        );
    }

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.reportsIntegracaoTetraPak.modoTela,
	aguardando: state.reportsIntegracaoTetraPak.aguardando,
	registro: state.reportsIntegracaoTetraPak.registro,
	lista: state.reportsIntegracaoTetraPak.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, getLista }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ReportsIntegracaoTetraPak);
